/** Компонента для отображения значений из триплета в формате HTML 
 * 1. Используются результат запроса вида PredicatSubjectRequest из request.js
 * 2. Результатом является два столбца с именем predicat и object
 * 3. Отображается либо одно значение либо массив значений, сформированный JSON.stringify(data)
*/
import React from 'react';
import parse  from 'html-react-parser';
import { getValues } from '../../virtuoso/helper'

/** Отображение значения по умолчанию. Получается список всех доступных значения, фильтруется по языку. */
export const MakeHTMLValue = ({uri, lang, values}) => {
  //console.log("MakeDefaultValue", uri, lang, values);
  return AdvMakeHTMLValue ({uri, lang, values, predicatVar:"predicat", objectVar: "object"});
}

export const AdvMakeHTMLValue = ({uri, lang, values, predicatVar, objectVar}) => {
  const value = getValues(uri, lang, values, predicatVar, objectVar);
  return parse((value.length === 0)?"":value.replaceAll("xhtml:", ""));
}

export class ViewHTMLComponent extends React.Component {
  render(){
    return(
      <MakeHTMLValue {...this.props} />
    )
  }
}